<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>開放時間設定</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>開放時間設定</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="right">
              <div align="left">
                開放時間：
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> ~
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />
                <a href="#" @click.prevent="formSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">儲存</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        startDate: null,
        endDate: null
      }
    };
  },
  mounted() {
    this.$http.get("/api/military/opening-date").then(a => {
      if (a.body) {
        this.form.startDate = a.body.startDate;
        this.form.endDate = a.body.endDate;
      }
    });
  },
  methods: {
    formSubmit() {
      if (this.form.startDate == "" || this.form.endDate == "") {
        alert("『開放時間』 尚未填寫");
        return false;
      }
      let sd = new Date(this.form.startDate),
        ed = new Date(this.form.endDate);
      if (sd > ed) {
        alert("『開始時間』請晚於『結束時間』")
        return false;
      }
      this.$http
        .post("/api/military/opening-date", this.form)
        .then(a => {
          if (a.body.status) {
            alert("儲存成功");
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
  }
};
</script>

<style>
</style>